import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { marked } from 'marked';
import { Observable } from 'rxjs';

@Injectable()
export class MarkdownService {
    constructor(private http: HttpClient) {}

    getMarkdownFile(markdownFile): Observable<string> {
        return this.http.get(markdownFile, { responseType: 'text' });
    }

    convertToHTML(mdAsText): string {
        return marked(mdAsText);
    }
}
